export const initSubRoutes = (route) => {
    Object.entries(route.subroutes).forEach(([index, subroute]) => {
        // eslint-disable-next-line no-param-reassign
        subroute.parent = route;
        // eslint-disable-next-line no-param-reassign
        route.subroutes[index] = subroute;
    });
    return route;
};

const construirePath = (route) => {
    if (route.parent) {
        return construirePath(route.parent) + route.route;
    }
    return route.route;
};

export const getPath = (route, params = {}) => {
    let path = construirePath(route);

    Object.entries(params).forEach((param) => {
        path = path.replaceAll(`:${param[0]}`, param[1]);
    });

    return path;
};

export const calculFilArianne = (route) => {
    if (route.parent) {
        const infoFilArianne = calculFilArianne(route.parent);
        infoFilArianne.push({
            nom: route.nom,
            route: infoFilArianne[infoFilArianne.length - 1].route + route.route,
        });
        return infoFilArianne;
    }
    return [{ nom: route.nom, route: route.route }];
};
